import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaUniversalAccess, FaUser, FaTools, FaGreaterThan, FaPlay, FaSave, FaRedo, FaUsers } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar';
import Ajouter_acces from './ajouter_acces';
import useAuth from '../../dashboard/useAuth';
import { BsPeople } from 'react-icons/bs';
import axios from 'axios';

const Liste_groupe = ({ titre }) => {
    useAuth()
    const existingAcces = { acces: [] }; // Ensure this is defined
    const [parcours, setParcours] = useState([]);

    const [groupes, setGroupes] = useState([]);
    const [selectedGroupe, setSelectedGroupe] = useState(null);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [groupeAcces, setGroupeAcces] = useState(null); // État pour stocker les accès existants
    const [expandedGroupeIds, setExpandedGroupeIds] = useState([]);
    const [groupeDescriptionOverflows, setGroupeDescriptionOverflows] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Nombre d'éléments par page
    const totalItems = groupes.length;  // Si 'formationList' contient toutes les formations

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('IDDDD');
    const navigate = useNavigate();

    const [userData, setUserData] = useState([]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`);
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
                console.log(data)
            } catch (error) {
                console.error('Erreur lors de la récupération des données utilisateur:', error);
            }
        };

        fetchUserData();
    }, [user_id]);

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Groupe"; // Définit le titre de la page
        }
    }, [user_id]);



    const fetchGroupes = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/liste-groupes/${user_id}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupes(data);
                setIsLoading(false)
            } else {
                console.error('Erreur lors de la récupération des groupes');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };




    useEffect(() => {

        fetchGroupes();
    }, []); // fetchGroupes ne s'exécute que lorsque userData est défini


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            fetchGroupes()
        }, 3000);
    };

    const handleRowClick = (groupe) => {
        setSelectedGroupe(groupe);
    };


    const handleDeleteGroupe = async () => {
        if (selectedGroupe) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-groupe/${selectedGroupe.id}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setGroupes(groupes.filter((groupe) => groupe.id !== selectedGroupe.id));
                    setSelectedGroupe(null);

                    // Stocker le message de succès dans localStorage
                    showAlert('Groupe supprimé avec succès !');
                } else {
                    console.error('Erreur lors de la suppression du groupe');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleCloseModal = () => setShowModal(false);

    const handleAccesChange = async (accesString) => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-acces-groupe/${selectedGroupe.id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ acces: accesString }),
            });

            if (response.ok) {
                const responseData = await response.json(); // Lire la réponse une seule fois
                console.log('Accès enregistrés avec succès:', responseData);

                // Stocker le message dans localStorage
                showAlert('Accès enregistrés avec succès !');

                setGroupeAcces(responseData); // Mettre à jour l'état avec les données reçues

                // Fermer le modal
                setShowModal(false);
            } else {
                const errorData = await response.json();
                console.error('Erreur lors de l\'enregistrement des accès:', errorData);
            }

        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchGroupeAcces = async (groupeId) => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/groupe-acces/${groupeId}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupeAcces(data); // Enregistrer les accès dans l'état
                console.log("Acces :", data.acces)
            } else {
                console.error('Erreur lors de la récupération des accès du groupe');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const filteredGroupes = groupes.filter(groupe =>
        groupe.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        groupe.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        groupe.type_groupe.toLowerCase().includes(searchTerm.toLowerCase()) ||
        groupe.nombre_utilisateurs.toString().includes(searchTerm.toLowerCase()) ||
        groupe.ajoute_par.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedGroupes = [...filteredGroupes].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handleShowDeleteModal = () => {
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    // Pagination logic
    const indexOfLastGroupe = currentPage * itemsPerPage;
    const indexOfFirstGroupe = indexOfLastGroupe - itemsPerPage;
    const currentGroupes = sortedGroupes.slice(indexOfFirstGroupe, indexOfLastGroupe);
    const totalPages = Math.ceil(sortedGroupes.length / itemsPerPage);

    // Gestion du changement d'éléments par page
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Réinitialiser à la première page
    };

    const handleToggleDescription = (id) => {
        console.log("Toggling description for ID:", id); // Vérifiez l'identifiant
        setExpandedDescriptions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const checkGroupeDescriptionOverflow = (groupes) => {
        groupes.forEach((groupe) => {
            const element = document.getElementById(`groupe-description-${groupe.id}`);
            if (element) {
                setGroupeDescriptionOverflows((prev) => ({
                    ...prev,
                    [groupe.id]: element.scrollHeight > element.clientHeight,
                }));
            }
        });
    };

    useEffect(() => {
        checkGroupeDescriptionOverflow(groupes);
    }, [groupes]);


    const handleConfigurer = (groupe) => {
        if (groupe) {
            navigate(`/Configurer-groupe`, {
                state: { groupe_id: groupe.id }, // Passage de l'ID par l'état
            });
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');
  
    const verifGroupe = async () => {
      const groupeStored = localStorage.getItem('groupe');
      const accesGroupeStored = localStorage.getItem('accesGroupe');
  
      if (groupeStored && accesGroupeStored) {
        setGroupeId(groupeStored);
        setAccesGroupe(JSON.parse(accesGroupeStored));
      } else {
        try {
          const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
          if (response.status === 200) {
            const data = response.data;
            setGroupeId(data.groupe);
  
            let cleanedAccessArray = [];
            if (Array.isArray(data.acces)) {
              cleanedAccessArray = data.acces.map((item) =>
                item.acces
                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                  : []
              ).flat();
  
              setAccesGroupe(cleanedAccessArray);
            }
  
            localStorage.setItem('groupe', data.groupe);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        } catch (error) {
          // console.error('Erreur lors de la vérification du groupe', error);
        }
      }
    };
  
    useEffect(() => {
      if (user_id) {
        verifGroupe();
      }
    }, [user_id]);
  
    if (!accesGroupe.includes("Groupes")) {
      return null;
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><BsPeople size={25} className='mr-2' /> Gestion des groupes</h2>
                            <small>Administration des groupes d'utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/Liste-groupe`}> Groupes</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    {/* <Header titre="Groupes" sous_titre="Dashboard" sous_titre1={<Link to={`/admin`} className='text-dark'>Administration</Link>} entete="Groupes"  user_id={user_id}/> */}
                    <div className="container mt-3">
                        <div className="">
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                                <h5>Liste des groupes</h5>

                                <div className="d-flex flex-column flex-md-row mt-3 mt-md-0">
                                    <div className="d-flex">
                                        {(!userData.coach_groupe || userData.coach_groupe === "") && (
                                            <Link to={`/Ajouter-groupe`} className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2">
                                                <FaPlus /> Créer un groupe
                                            </Link>
                                        )}
                                        <button
                                            onClick={() => handleConfigurer(selectedGroupe)}
                                            className={`btn mb-2 mb-md-0 ms-0 ms-md-2 mr-2 ${selectedGroupe ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedGroupe}
                                        >
                                            <FaUsers /> Configuration
                                        </button>
                                        <button
                                            onClick={() => handleShowDeleteModal(selectedGroupe)}
                                            className={`btn mb-2 mb-md-0 ms-0 ms-md-2 ${selectedGroupe ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedGroupe}
                                        >
                                            <FaTrash /> Supprimer
                                        </button>
                                    </div>
                                </div>

                            </div>


                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">

                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive">
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '15%' }} className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom')}>Nom{sortConfig.key === 'nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th style={{ width: '40%' }} className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('description')}>Description {sortConfig.key === 'description'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th style={{ width: '25%' }} className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nbre')}>Nbre d'utilisateurs {sortConfig.key === 'nbre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th style={{ width: '20%' }} className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('ajoute_par')}>Ajouté par {sortConfig.key === 'ajoute_par'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th style={{ width: '15%' }} className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('type_groupe')}>Type {sortConfig.key === 'type_groupe'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!isLoading ? (
                                                            currentGroupes.map((groupe) => {
                                                                const isExpanded = expandedDescriptions[groupe.id];
                                                                return (
                                                                    <tr
                                                                        key={groupe.id}
                                                                        onClick={() => handleRowClick(groupe)}
                                                                        className={`bg-white ${selectedGroupe && selectedGroupe.id === groupe.id ? 'bg-success text-white' : ''}`}
                                                                    >
                                                                        <td>
                                                                            {groupe.nom}
                                                                            <div className='lesInfos'>
                                                                                <small>Description :
                                                                                    <div
                                                                                        id={`groupe-description-${groupe.id}`}
                                                                                        className={`description-text ${expandedDescriptions[groupe.id] ? 'expanded' : ''}`}
                                                                                        style={{ maxHeight: expandedDescriptions[groupe.id] ? 'none' : '3em', overflow: 'hidden', whiteSpace: 'pre-wrap' }}
                                                                                    >
                                                                                        {groupe.description ? (
                                                                                            // Utilisation de dangerouslySetInnerHTML pour afficher le contenu HTML
                                                                                            <span dangerouslySetInnerHTML={{ __html: groupe.description }}></span>
                                                                                        ) : (
                                                                                            <em>Non défini</em> // Affichage en italique si la description n'est pas définie
                                                                                        )}
                                                                                    </div>
                                                                                    {groupe.description && groupeDescriptionOverflows[groupe.id] && (
                                                                                        <button
                                                                                            onClick={() => handleToggleDescription(groupe.id)}
                                                                                            style={{ background: 'none', border: 'none', color: 'black', cursor: 'pointer', padding: 0 }}
                                                                                        >
                                                                                            {expandedDescriptions[groupe.id] ? 'Voir moins' : 'Voir plus...'}
                                                                                        </button>
                                                                                    )}
                                                                                </small>
                                                                                <small>Ajouté par : {groupe.ajoute_par}</small><br />
                                                                                <small>Statut : {groupe.type_groupe}</small>
                                                                            </div>
                                                                        </td>
                                                                        <td className="d-none d-md-table-cell" style={{ position: 'relative' }}>
                                                                            <div
                                                                                id={`groupe-description-${groupe.id}`}
                                                                                className={`description-text ${expandedDescriptions[groupe.id] ? 'expanded' : ''}`}
                                                                                style={{ maxHeight: expandedDescriptions[groupe.id] ? 'none' : '3em', overflow: 'hidden', whiteSpace: 'pre-wrap' }}
                                                                            >
                                                                                {groupe.description ? (
                                                                                    // Utilisation de dangerouslySetInnerHTML pour afficher le contenu HTML
                                                                                    <span dangerouslySetInnerHTML={{ __html: groupe.description }}></span>
                                                                                ) : (
                                                                                    <em>Non défini</em> // Affichage en italique si la description n'est pas définie
                                                                                )}
                                                                            </div>
                                                                            {groupe.description && groupeDescriptionOverflows[groupe.id] && (
                                                                                <button
                                                                                    onClick={() => handleToggleDescription(groupe.id)}
                                                                                    style={{ background: 'none', border: 'none', color: 'black', cursor: 'pointer', padding: 0 }}
                                                                                >
                                                                                    {expandedDescriptions[groupe.id] ? 'Voir moins' : 'Voir plus...'}
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                        <td className="d-none d-md-table-cell">{groupe.nombre_utilisateurs}</td>

                                                                        <td className="d-none d-md-table-cell">{groupe.ajoute_par}</td>
                                                                        <td className="d-none d-md-table-cell">{groupe.type_groupe}</td>
                                                                    </tr>
                                                                );

                                                            })
                                                        ) : (
                                                            <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                                                <span
                                                                    className="spinner-border spinner-border-lg text-success"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                    style={{ width: '3rem', height: '3rem' }}
                                                                ></span>
                                                            </div>

                                                        )}



                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${currentPage === 1 ? 1 : (currentPage - 1) * itemsPerPage + 1} à ${currentPage * itemsPerPage > totalItems ? totalItems : currentPage * itemsPerPage
                                                        } sur ${totalItems}`}
                                                </div>

                                                <div>
                                                    {Array.from({ length: totalPages }, (_, index) => (
                                                        <button
                                                            key={index + 1}
                                                            onClick={() => setCurrentPage(index + 1)}
                                                            className={`btn ${currentPage === index + 1 ? 'btn-default' : 'btn-light'} mx-1`}
                                                        >
                                                            {index + 1}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Ajouter_acces
                        show={showModal}
                        handleClose={handleCloseModal}
                        onAccesChange={handleAccesChange}
                        liste_groupe={groupeAcces || []} // Ensure we pass an array
                    />

                    {/* Modal de confirmation de suppression */}
                    <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la Suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer le groupe <strong>{selectedGroupe?.nom}</strong> ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                Annuler
                            </Button>
                            <Button variant="success" onClick={handleDeleteGroupe}>
                                Supprimer
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>

            {/* Styles CSS pour les cellules fixes */}
            <style jsx>{`
    width: 300px; /* Ajustez cette valeur selon vos besoins */
    overflow: hidden; /* Évite le débordement de contenu */
    text-overflow: ellipsis; /* Ajoute des "..." pour le contenu tronqué si nécessaire */
    word-wrap: break-word; /* Permet au texte de s'enrouler et de casser les mots longs */
    overflow-wrap: break-word; /* Ajoute cette propriété pour la compatibilité */
    white-space: normal; /* Permet le retour à la ligne */
`}</style>
        </div>
    );
};

export default Liste_groupe;


